<script lang="ts">
  import type { AutosaveStatus } from "$lib/utils/autosave.svelte";
  import * as m from "$lib/paraglide/messages";
  import { cn } from "$lib/utils/cn";

  type Props = {
    status: AutosaveStatus;
    class?: string;
  };

  const { status, class: className }: Props = $props();

  const label = $derived.by(() => {
    switch (status) {
      case "pending":
        return m.autosave_pending();
      case "saving":
        return m.autosave_saving();
      case "saved":
        return m.autosave_saved();
      case "error":
        return m.autosave_error();
      default:
        return "";
    }
  });

  const tone = $derived.by(() => {
    switch (status) {
      case "pending":
        return "text-amber-700";
      case "saving":
        return "text-(--surface-fg-muted)";
      case "saved":
        return "text-success-600";
      case "error":
        return "text-(--surface-danger)";
      default:
        return "text-(--surface-fg-muted)";
    }
  });
</script>

{#if status !== "idle" && label}
  <span
    class={cn("text-xs font-medium tabular-nums", tone, className)}
    role="status"
    aria-live="polite"
  >
    {label}
  </span>
{/if}
